'use client';

import { ReactNode } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from '@/lib/app/theme';
import { THEME_STORAGE_KEY } from '@/lib/app/themePreference';

export default function ThemedApp({ children }: { children: ReactNode }) {
  // forceThemeRerender keeps theme.palette.mode in step with the scheme. Without it, MUI leaves
  // palette.mode at 'light' in CSS-variables mode, and components that pick colors in JS from
  // palette.mode would never turn dark.
  return (
    <ThemeProvider theme={theme} modeStorageKey={THEME_STORAGE_KEY} defaultMode="system" forceThemeRerender disableTransitionOnChange>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
